import { css } from 'styled-components';

export const titlePanelMixin = css`
  font-weight: ${({ theme: { boldText } }) => boldText.dark};
  color: ${({ theme: { colors } }) => colors['grey-5']};
`;
